// src/utils/maskAddress.js
//
// The day/night address on the vehicle journey is prefilled from a credit
// bureau lookup against the visitor's ID, so it is masked wherever it is shown
// back to them — the address-bar field while it is idle, and the summary in the
// side stepper — the same treatment the cell number and email already get.
//
// The rule: keep the first two characters of every word and bullet out the rest,
// so the address stays recognisable without reading as the real thing. The
// leading street number is hidden outright, since that is the part that pins an
// address to a specific house. Punctuation and spacing are left alone, so the
// masked value keeps the shape of an address.
//
//   22 Maria Du Plessis, Elarduspark, Pretoria, 0081
//   •• Ma••• Du Pl•••••, El•••••••••, Pr••••••, 00••
//
// Masking is display only. The raw value is what stays in formValues and what
// goes to the API — see FullAddressDay/FullAddressNight in utils/apiHelpers.js.

// The same bullet the cell number and email masks use, so the three masked
// fields read as one treatment.
const MASK_CHAR = '•';

export function maskAddress(value) {
  const address = String(value ?? '').trim();
  if (!address) return '';

  let isFirstWord = true;
  return address.replace(/[A-Za-z0-9]+/g, (word) => {
    const isLeadingWord = isFirstWord;
    isFirstWord = false;
    if (isLeadingWord && /^\d+$/.test(word))
      return MASK_CHAR.repeat(word.length);
    return word.slice(0, 2) + MASK_CHAR.repeat(Math.max(word.length - 2, 0));
  });
}

// Masks a question can ask for by name, so a rule shared by several fields
// lives here rather than being copied as a source string into every question
// file that needs it. A `mask` that is not a name is still treated as the body
// of a masking function (see TextFieldComponent), which is how the one-off cell
// and email masks are written.
export const NAMED_MASKS = {
  address: maskAddress,
};

export function resolveNamedMask(mask) {
  if (typeof mask !== 'string') return null;
  return Object.prototype.hasOwnProperty.call(NAMED_MASKS, mask)
    ? NAMED_MASKS[mask]
    : null;
}
